module.exports = __webpack_public_path__ + "static/img/07.4dbd3cde.gif";